(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["halloween-ticket-shop"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('halloween-ticket-shop')) {
    customElements.define('halloween-ticket-shop', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        this.form = this.querySelector('.hts__form');
        if (!this.form) return;
        this.quantity = this.form.querySelector('[name="quantity"]');
        this.buy = this.form.querySelector('.hts__buy');
        this.label = this.form.querySelector('[data-button-label]');
        this.error = this.form.querySelector('[data-error]');
        this.total = this.form.querySelector('[data-total]');
        this.busy = false;
        this.capturePromoter();
        const options = { signal: this.abort.signal };
        this.setAttribute('data-enhanced', '');
        this.querySelectorAll('[data-quantity-change]').forEach(button => {
          button.hidden = false;
          button.addEventListener('click', () => {
            const change = Number(button.dataset.quantityChange);
            this.quantity.value = this.normalizedQuantity(Number(this.quantity.value) + change * this.step);
            this.updateTotals();
          }, options);
        });
        this.form.addEventListener('change', event => {
          if (event.target.name === 'id') this.updateVariant();
          if (event.target.name === 'quantity') {
            this.quantity.value = this.normalizedQuantity(this.quantity.value);
            this.updateTotals();
          }
          this.error.hidden = true;
        }, options);
        this.quantity.addEventListener('input', () => this.updateTotals(), options);
        this.form.addEventListener('submit', event => this.submitTicket(event), options);
        this.updateVariant();
      }
      // Latest valid promoter link for this product in the current browser tab.
      capturePromoter() {
        const source = new URLSearchParams(window.location.search).get('utm_source') || '';
        const match = source.match(/^promoter_([a-z0-9][a-z0-9_-]{0,63})$/i);
        const key = 'hts-promoter:' + this.dataset.productId;
        this.promoter = '';
        if (match) {
          this.promoter = match[1].toLowerCase();
          try { window.sessionStorage.setItem(key, this.promoter); } catch (_) {}
        } else {
          try {
            const saved = window.sessionStorage.getItem(key) || '';
            if (/^[a-z0-9][a-z0-9_-]{0,63}$/.test(saved)) this.promoter = saved;
          } catch (_) {}
        }
      }
      async savePromoterToCart() {
        // Clear stale cart attribution when this visit has no promoter.
        // Per-ticket properties are authoritative if a cart mixes referrals.
        const response = await fetch(this.dataset.updateUrl, {
          method: 'POST',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ attributes: { '__Promoter': this.promoter || '' } })
        });
        const payload = await response.json();
        if (!response.ok) throw new Error(payload.description || payload.message || this.dataset.errorText);
      }
      disconnectedCallback() { this.abort?.abort(); }
      selectedVariant() { return this.form.querySelector('[name="id"]:checked:not(:disabled)'); }
      normalizedQuantity(value) {
        let number = Number(value);
        if (!Number.isFinite(number)) number = this.min;
        number = Math.max(this.min, number);
        if (Number.isFinite(this.max)) number = Math.min(number, this.max);
        return this.min + Math.floor((number - this.min) / this.step) * this.step;
      }
      updateVariant() {
        const variant = this.selectedVariant();
        this.min = Number(variant?.dataset.min || 1);
        this.step = Number(variant?.dataset.step || 1);
        this.max = variant?.hasAttribute('data-max') ? Number(variant.dataset.max) : Infinity;
        this.quantity.min = this.min;
        this.quantity.step = this.step;
        if (Number.isFinite(this.max)) this.quantity.max = this.max;
        else this.quantity.removeAttribute('max');
        this.quantity.value = this.normalizedQuantity(this.quantity.value);
        this.quantity.disabled = !variant;
        this.buy.disabled = !variant || this.max < this.min || this.busy;
        this.updateTotals();
      }
      updateTotals() {
        const variant = this.selectedVariant();
        if (variant) {
          const amount = Number(variant.dataset.price) * this.normalizedQuantity(this.quantity.value) / 100;
          this.total.textContent = new Intl.NumberFormat(this.dataset.locale || 'en', {
            style: 'currency', currency: this.dataset.currency || 'EUR'
          }).format(amount);
        }
        this.querySelectorAll('[data-quantity-change]').forEach(button => {
          const next = Number(this.quantity.value) + Number(button.dataset.quantityChange) * this.step;
          button.disabled = !variant || this.busy || next < this.min || next > this.max;
        });
      }
      async submitTicket(event) {
        event.preventDefault();
        if (this.busy || !this.selectedVariant()) return;
        if (!this.form.reportValidity()) return;
        const body = new FormData(this.form);
        if (this.promoter) body.set('properties[_Promoter]', this.promoter);
        this.busy = true;
        this.buy.disabled = true;
        this.buy.setAttribute('aria-busy', 'true');
        this.label.textContent = this.dataset.loadingText;
        this.error.hidden = true;
        this.form.querySelector('.hts__variants').disabled = true;
        this.quantity.disabled = true;
        this.updateTotals();
        try {
          // Complete attribution before adding tickets; an update failure adds no tickets.
          await this.savePromoterToCart();
          const response = await fetch(this.dataset.addUrl, {
            method: 'POST', headers: { Accept: 'application/json' }, body, credentials: 'same-origin'
          });
          const payload = await response.json();
          if (!response.ok) throw new Error(payload.description || payload.message || this.dataset.errorText);
          const destination = this.dataset.destination === 'checkout'
            ? (window.Shopify?.routes?.root || '/') + 'checkout'
            : this.dataset.cartUrl;
          window.location.assign(destination);
        } catch (error) {
          this.error.textContent = error.message === 'Failed to fetch' ? this.dataset.errorText : (error.message || this.dataset.errorText);
          this.error.hidden = false;
          this.busy = false;
          this.form.querySelector('.hts__variants').disabled = false;
          this.quantity.disabled = false;
          this.buy.removeAttribute('aria-busy');
          this.label.textContent = this.dataset.buttonText;
          this.updateVariant();
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
